import {
  Component, Input, ChangeDetectorRef, ChangeDetectionStrategy, ViewChild,
 } from '@angular/core';
import * as _ from 'lodash';

import { DynamicComponentLoader } from 'shared/base/dynamic-component-loader.service';
import { ExportManagerService } from 'shared/export-manager/export-manager.service';
import { LoaderComponent } from 'shared/loader/loader.component';
import { LogsComponent } from 'shared/logs/logs.component';
import { BrandService } from 'shared/brand/brand.service';
import { statusLookup } from 'shared/receivers/receivers-statuses';

import { statusRules } from './receiver-logs-helpers';
import { ExportLogsComponent } from './export-logs/export-logs.component';


@Component({
  moduleId: module.id,
  selector: 'receiver-logs-tab',
  templateUrl: 'receiver-logs.component.html',
  styleUrls: ['receiver-logs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReceiverLogsTabComponent {
  exportLogs: any[] = [];
  receiver: any;
  timezone: string;
  statusRules = statusRules;
  statusLookup = statusLookup;
  exportLogsLoading: boolean = false;
  receiverLogsLoading: boolean = false;


  @ViewChild(LoaderComponent, {static: false})
  loader: LoaderComponent | void;

  @ViewChild(LogsComponent, {static: false})
  receiverLogsComponent: LogsComponent | void;

  @ViewChild(ExportLogsComponent, {static: false})
  exportLogsComponent: ExportLogsComponent | void;

  constructor(
    private dynamicComponentLoader: DynamicComponentLoader,
    private brandService: BrandService,
    private ref: ChangeDetectorRef,
  ) {}

  /*******************************************
  * COMPONENT GETTERS
  *******************************************/

  get receiverId(): string {
    return _.get(this.receiver, '_id');
  }

  get brandId(): string {
    return this.brandService.getBrand();
  }

  /*******************************************
  * COMPONENT PUBLIC METHODS
  *******************************************/

  public setData(receiver: any, timezone: string) {
    this.receiver = receiver;
    this.timezone = timezone;
    this.ref.markForCheck();
    if (this.exportLogsComponent instanceof ExportLogsComponent) {
      this.exportLogsComponent.updateLogs();
    }
    this.exportLogsLoading = true;
    if (this.receiverLogsComponent instanceof LogsComponent) {
      this.receiverLogsComponent.updateLogs(this.receiverId);
    }
    this.receiverLogsLoading = true;
    this.showLoader();
  }

  /*******************************************
  * COMPONENT HANDLERS
  *******************************************/

  onExportLogsFetch(loading: boolean) {
    this.exportLogsLoading = loading;
    this.showLoader();
  }

  onReceiversLogsFetch(loading: boolean) {
    this.receiverLogsLoading = loading;
    this.showLoader();
  }

  /*******************************************
  * COMPONENT PRIVATE METHODS
  *******************************************/

  private showLoader() {
    if (!this.loader) {
      return;
    }
    if (this.exportLogsLoading || this.receiverLogsLoading) {
      this.loader.show();
    } else {
      this.loader.hide();
    }
  }
}
